export default {
  methods: {
    /**
     *
     * 根据传入的对象和 keys
     * 返回一个新对象，由 keys 和对应数据组成
     * @param {*} obj
     * @param {*} keys
     * @returns
     */
    pickBy(obj, ...keys) {
      return Object.keys(obj)
        .filter(key => keys.includes(key))
        .reduce(
          (acc, key) => ({
            ...acc,
            [key]: obj[key],
          }),
          {},
        );
    },
  },
};
